import React from 'react';
import { MoonIcon, FolderSearchIcon, RepeatIcon, HelpCircleIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
const frictions = [{
  icon: MoonIcon,
  title: 'Planning after a full day',
  body: 'Still building tomorrow’s class during your personal time.'
}, {
  icon: FolderSearchIcon,
  title: 'Resources everywhere',
  body: 'Notes, videos, screenshots, books and saved posts.'
}, {
  icon: RepeatIcon,
  title: 'Repeating the same sequences',
  body: 'When time runs short, familiar classes become the default.'
}, {
  icon: HelpCircleIcon,
  title: 'Second-guessing the flow',
  body: 'Timing, transitions, modifications and class balance still need to be figured out.'
}];
export function ProblemSection() {
  return <section className="w-full bg-ivory py-10 sm:py-14 lg:py-20" aria-labelledby="problem-heading" data-id="element-155" data-mp="1p1j114no37wx">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-156" data-mp="1k3r7653gpbq3">
        <div className="mx-auto max-w-2xl text-center" data-id="element-157" data-mp="1k5al3p1nbaop">
          <div className="flex justify-center" data-id="element-158" data-mp="jeeo8ey313eb">
            <SectionLabel data-id="element-159" data-mp="oc7xjguomdit">The reality</SectionLabel>
          </div>
          <h2 id="problem-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.1] text-ink sm:text-4xl" data-id="element-160" data-mp="ocg7azvid2ps">
            Does this sound familiar?
          </h2>
          <p className="mt-4 text-[0.95rem] leading-relaxed text-muted sm:text-lg" data-id="element-161" data-mp="123ld6jpgyr8k">
            Tomorrow you have another class to teach. So tonight you’re searching old notes, saved
            posts, videos and previous sequences trying to build something that flows, fits your
            students and feels complete.
          </p>
          <p className="mx-auto mt-3 max-w-lg text-[0.95rem] leading-relaxed text-ink sm:text-lg" data-id="element-162" data-mp="1g3nsby6e76k4">
            Not because you don’t know yoga. Because knowing yoga and having a complete class ready
            to teach are two different things.
          </p>
        </div>

        <ul className="mt-7 grid grid-cols-2 gap-2.5 sm:gap-4" data-id="element-163" data-mp="p00nlxyty12t">
          {frictions.map(({
          icon: Icon,
          title,
          body
        }) => <li key={title} className="flex h-full flex-col items-center gap-2 rounded-2xl border border-sandDark bg-cream/70 px-3 py-4 text-center sm:px-5" data-id="element-164" data-mp="k1z1f463xln4">
              <Icon className="h-4 w-4 shrink-0 text-clay" aria-hidden="true" data-id="element-165" data-mp="tyaj69ogv3oy" />
              <span className="font-serif text-[0.72rem] font-semibold uppercase leading-tight tracking-label text-ink sm:text-sm" data-id="element-166" data-mp="17ylatexlomb6">
                {title}
              </span>
              <span className="text-[0.76rem] leading-snug text-muted sm:text-[0.85rem]" data-id="element-167" data-mp="12y7a6hybwen6">
                {body}
              </span>
            </li>)}
        </ul>

        <p className="mx-auto mt-7 max-w-2xl text-center font-serif text-[1.05rem] font-semibold uppercase leading-tight text-ink sm:text-2xl" data-id="element-168" data-mp="1cqmtpjp9xba6">
          Your yoga knowledge isn’t the problem.
          <span className="mt-1 block text-forest" data-id="element-169" data-mp="1lscmasuw6g9j">
            The problem is having to rebuild the class every time.
          </span>
        </p>
      </div>
    </section>;
}